import type { Notification } from '../services/notificationApi';

export const TENANT_OPEN_INVOICE_EVENT = 'kcn:tenant-open-invoice';

export function isTenantRentDueNotification(notification: Notification): boolean {
  const source = notification.metadata?.source || notification.content?.source;
  return source === 'tenant_rent_due' || notification.metadata?.action === 'open_invoice';
}

export function isTenantRentPaidNotification(notification: Notification): boolean {
  const source = notification.metadata?.source || notification.content?.source;
  return source === 'tenant_rent_paid';
}

export function isTenantContractCancelledNotification(notification: Notification): boolean {
  const source = notification.metadata?.source || notification.content?.source;
  return source === 'contract_cancelled';
}

export function isTenantAppNotification(notification: Notification): boolean {
  return (
    isTenantRentDueNotification(notification) ||
    isTenantRentPaidNotification(notification) ||
    isTenantContractCancelledNotification(notification)
  );
}

export function requestTenantOpenInvoice(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TENANT_OPEN_INVOICE_EVENT));
}
